import { Button } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

function useAdmins() {
  const [admins, setAdmins] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/admins')
      .then((response) => response.json())
      .then((data) => {
        setAdmins(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { admins, setAdmins };
}

export default function Admins() {
  const { admins } = useAdmins();
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/admins-update/${id}`);
  };

  const columns = [
    {
      name: 'username',
      label: 'Nombre De Usuario',
    },
    {
      name: 'createdAt',
      label: 'Fecha De Creación',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(admins[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    let c = window.confirm(
      '¿Estás seguro de eliminar los administradores seleccionados?'
    );
    if (c) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/admins/${
            admins[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
          }
        );
        let data = await response.json();
        if (data.success) {
        }
      });
    }
    return true;
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás visualizar la lista de
        adminsitradores autorizados por la editorial.
      </p>
      <MUIDataTable
        title={'Listado de administradores'}
        data={admins}
        columns={columns}
        options={{
          filter: false,
          onRowsDelete: (rowsDelete) => {
            return handleDelete(rowsDelete);
          },
        }}
      />
    </div>
  );
}
